import { useConfirm } from './useConfirm'
import { useCurrentUser } from './useCurrentUser'
import { useDisconnectCustomerSchoolClass } from './mutations/useDisconnectCustomerSchoolClass'

const useConfirmRemoveSchoolClass = (schoolClass) => {
  const { confirm } = useConfirm()
  const { currentUser } = useCurrentUser()
  const { post } = useDisconnectCustomerSchoolClass()

  const confirmRemoveSchoolClass = async (onSuccess) => {
    const confirmed = await confirm({
      title: schoolClass.name,
      text: 'Är du säker på att du vill dölja denna klass i ditt lärarrum? Böcker som du har delat med klassen kommer att försvinna för eleverna.',
      confirmText: 'Ja, dölj klass',
      cancelText: 'Avbryt',
    })

    if (!confirmed) return

    const res = await post({
      disconnectSchoolClasses: [schoolClass.id],
      id: currentUser.id,
    })

    if (res.success && typeof onSuccess == 'function') {
      onSuccess && onSuccess()
    }
  }

  return { confirmRemoveSchoolClass }
}

export { useConfirmRemoveSchoolClass }
